import * as z from 'zod/mini';
export const UserType = z.enum(['PATIENT', 'STAFF']);
//# sourceMappingURL=UserType.js.map